"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToUrl = function (str) {
    return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
        .replace(/&/g, "-and-")
        .replace(/[^a-z0-9\-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-*/, "")
        .replace(/-*$/, "");
};
exports.inEnum = function (enu, value) { return Object.values(enu).includes(value); };
var mergeDeepWithPath = function (target, source, allowNullPaths) {
    var src = __assign({}, source);
    Object.keys(src).forEach(function (k) {
        var key = k;
        var isValueObject = src[key] !== null && typeof src[key] === "object" && !Array.isArray(src[key]);
        var isNullable = !!(allowNullPaths && allowNullPaths.find(function (a) { return a[0] === key; }));
        if (target[key] !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            src[key] = isValueObject
                ? __assign({}, mergeDeepWithPath(target[key], src[key], allowNullPaths && allowNullPaths.length > 1 && allowNullPaths.map(function (_a) {
                    var _b = __read(_a), _ = _b[0], next = _b.slice(1);
                    return next;
                }))) : isNullable
                ? target[key] !== undefined
                    ? target[key]
                    : src[key]
                : target[key] != undefined
                    ? target[key]
                    : src[key];
        }
    });
    return src;
};
exports.mergeDeep = function (target, source, allowNullPaths) {
    return mergeDeepWithPath(target, source, allowNullPaths && allowNullPaths.map(function (a) { return a.split("."); }));
};
exports.flattenDeep = function (arr) { return arr.reduce(function (flat, toFlatten) { return flat.concat(Array.isArray(toFlatten) ? exports.flattenDeep(toFlatten) : toFlatten); }, []); };
exports.isDayValid = function (dayNumber) { return dayNumber >= 0 && dayNumber <= 6; };
exports.isHourValid = function (hourNumber) { return hourNumber >= 0 && hourNumber < 24; };
exports.isIDValid = function (id, allowNegative) { return !(!allowNegative && id <= 0); };
exports.isEmailValid = function (email) {
    return !!email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
};
exports.isPhoneValid = function (phone) { return !!phone.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im); };
exports.isPasswordValid = function (pwd) { return (pwd === null || pwd === void 0 ? void 0 : pwd.length) > 6; };
var MIN_TIMESTAMP_ALLOWED = 1;
var MAX_TIMESTAMP_ALLOWED = 1893456000000;
exports.isTimestampValid = function (ts, capped) { return ts > 0 && (!capped || (ts >= MIN_TIMESTAMP_ALLOWED && ts <= MAX_TIMESTAMP_ALLOWED)); };
exports.isDefined = function (o) { return o != null; };
exports.zip = function () {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var n = arrays.reduce(function (acc, cur) { return Math.max(acc, cur.length); }, 0);
    return Array.from(Array(n)).map(function (_, i) { return arrays.map(function (arr) { return (exports.isDefined(arr[i]) ? arr[i] : undefined); }); });
};
